const options = {
  5: "bg-sky-200/5",
  10: "bg-sky-200/10",
  25: "bg-sky-200/25",
  50: "bg-sky-200/50",
  75: "bg-sky-200/75",
  90: "bg-sky-200/90",
  100: "bg-sky-200",
};

const from = {
  5: "from-sky-200/5",
  10: "from-sky-200/10",
  25: "from-sky-200/25",
  50: "from-sky-200/50",
  75: "from-sky-200/75",
  90: "from-sky-200/90",
  100: "from-sky-200",
};

export default function getBackgroundSky200(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
